import { useMemo } from 'react'; // React hook to memoize computed values
import { useLocation } from 'react-router-dom'; // Hook to read the current URL/location

/**
 * Custom hook that returns *all* query parameters as a plain object.
 *
 * @returns An object where each key is a query-param name and each value is its string value.
 */
const useQueryParams = (): Record<string, string> => {
  const { search } = useLocation(); // Get the raw query string (e.g. "?foo=bar&baz=qux")

  return useMemo(() => {
    const params = new URLSearchParams(search); // Parse the query string into an iterable map
    const result: Record<string, string> = {}; // Prepare an object to collect key/value pairs

    // Iterate over each entry in URLSearchParams
    params.forEach((value, key) => {
      result[key] = value; // Assign each param to the result object
    });

    return result; // Return the populated object
  }, [search]); // Re-run only when the `search` string changes
};

export default useQueryParams; // Export so you can import and use in any component
